import { useState } from 'react';

const faqs = [
  {
    question: 'O que são direitos creditórios e como funcionam na prática?',
    answer: 'Direitos creditórios são ativos financeiros que representam o direito de receber valores futuros decorrentes de operações comerciais, financeiras ou de prestação de serviços. Na prática, empresas podem utilizar esses ativos como instrumento de planejamento tributário legal, estruturando operações que permitem a compensação ou redução de tributos como IRPJ, CSLL, PIS e COFINS, sempre dentro dos limites estabelecidos pela legislação brasileira.'
  },
  {
    question: 'A redução de impostos com direitos creditórios é legal e segura?',
    answer: 'Sim. Todas as operações estruturadas pela Feenex são 100% amparadas pela legislação vigente, incluindo o Código Tributário Nacional e normas da Receita Federal. Cada operação conta com parecer jurídico de advogados tributaristas especializados e é auditável a qualquer momento. Nosso histórico é de zero autuações fiscais, o que demonstra a solidez e conformidade das nossas soluções.'
  },
  {
    question: 'Qual o percentual de redução de impostos que minha empresa pode alcançar?',
    answer: 'O percentual varia conforme o porte, regime tributário e setor da empresa. Em média, nossos clientes alcançam 20% de redução na carga tributária. Empresas do Lucro Real com faturamento acima de R$ 5 milhões ao ano tendem a ter maior potencial de economia. O diagnóstico inicial gratuito é o primeiro passo para identificar o potencial específico do seu negócio.'
  },
  {
    question: 'Quais impostos podem ser reduzidos com as soluções da Feenex?',
    answer: 'As soluções da Feenex atuam principalmente sobre IRPJ (Imposto de Renda Pessoa Jurídica), CSLL (Contribuição Social sobre o Lucro Líquido), PIS e COFINS. Dependendo da estrutura da empresa, também é possível otimizar outros tributos federais. A estratégia é sempre personalizada após análise detalhada da situação tributária de cada cliente.'
  },
  {
    question: 'O que é ativo moeda e como ele se diferencia dos direitos creditórios?',
    answer: 'O ativo moeda é uma modalidade específica de ativo financeiro reconhecido pela legislação brasileira que pode ser utilizado como meio de pagamento de obrigações tributárias. Enquanto os direitos creditórios representam recebíveis futuros, o ativo moeda possui liquidez imediata para fins fiscais. Ambos são instrumentos complementares dentro do planejamento tributário estruturado que a Feenex oferece.'
  },
  {
    question: 'Minha empresa precisa ser de qual porte ou setor para se beneficiar?',
    answer: 'As soluções da Feenex são voltadas para empresas tributadas pelo Lucro Real, geralmente com faturamento anual acima de R$ 5 milhões. Atendemos empresas de diversos setores: indústria, comércio, agronegócio, saúde, tecnologia, construção civil e serviços. O critério principal é o regime tributário e o volume de tributos pagos, não o setor de atuação.'
  },
  {
    question: 'Quanto tempo leva para ver os resultados na prática?',
    answer: 'Após a conclusão do diagnóstico e estruturação da solução — processo que leva em média de 30 a 60 dias — os benefícios tributários começam a ser aplicados já no período fiscal seguinte. O monitoramento contínuo é realizado por até 5 anos, garantindo que os resultados sejam sustentáveis e que a estratégia seja ajustada conforme mudanças na legislação ou na estrutura da empresa.'
  },
  {
    question: 'Como funciona o processo de contratação e quais são os custos?',
    answer: 'O processo começa com um diagnóstico inicial gratuito, sem compromisso. Após a análise, apresentamos uma proposta personalizada com projeção de economia e estrutura de honorários. Nossa remuneração é baseada em performance — ou seja, alinhamos nossos interesses aos seus resultados. Não há custos fixos elevados antes de comprovada a viabilidade da operação para o seu caso.'
  },
  {
    question: 'A Receita Federal pode questionar ou autuar minha empresa por usar essas estratégias?',
    answer: 'As operações estruturadas pela Feenex são desenhadas justamente para resistir a qualquer questionamento fiscal. Contamos com pareceres jurídicos robustos, documentação completa e estruturas que já foram testadas e validadas. Nosso histórico de zero autuações em mais de 15 anos de operação com a Monetali é a melhor evidência da solidez das nossas soluções. Em caso de qualquer questionamento, nossa equipe jurídica acompanha o cliente integralmente.'
  },
  {
    question: 'Como a Feenex garante a transparência e o acompanhamento das operações?',
    answer: 'Cada cliente recebe relatórios mensais detalhados com todos os indicadores da operação, economia tributária acumulada e status de conformidade. Um gestor de conta dedicado está disponível para esclarecer dúvidas e apresentar os resultados. Além disso, disponibilizamos auditoria independente a qualquer momento, garantindo total visibilidade sobre cada etapa do processo.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-feenex-gold/10 rounded-full mb-4">
            <span className="text-sm font-semibold text-feenex-gold uppercase tracking-wider">Tire Suas Dúvidas</span>
          </div>
          <h4 className="text-4xl lg:text-5xl font-bold text-feenex-blue mb-6">
            <a href="#faq" className="hover:text-feenex-gold transition-colors">
              Perguntas Frequentes sobre Direitos Creditórios e Redução de Impostos
            </a>
          </h4>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Entenda como as soluções da Feenex funcionam, quais empresas se beneficiam e como garantimos segurança jurídica em cada operação.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-12 items-start">
          {/* Left: Highlight Card */}
          <div className="lg:col-span-2">
            <div className="bg-feenex-blue rounded-lg p-8 sticky top-28">
              <div className="w-14 h-14 bg-feenex-gold/20 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-question-answer-line text-2xl text-feenex-gold"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Ainda tem dúvidas?
              </h3>
              <p className="text-white/70 text-sm leading-relaxed mb-8">
                Nossa equipe de especialistas em direitos creditórios e planejamento tributário está pronta para analisar o caso específico da sua empresa sem compromisso.
              </p>
              <a
                href="#contato"
                className="inline-flex items-center gap-2 w-full justify-center px-6 py-3 bg-feenex-gold hover:bg-feenex-gold/90 text-feenex-blue font-semibold rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
              >
                Falar com Especialista
                <i className="ri-arrow-right-line"></i>
              </a>

              <div className="mt-8 pt-8 border-t border-white/10 space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-feenex-gold/10 rounded-full">
                    <i className="ri-shield-check-line text-feenex-gold text-sm"></i>
                  </div>
                  <span className="text-white/70 text-sm">Zero autuações fiscais</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-feenex-gold/10 rounded-full">
                    <i className="ri-file-shield-2-line text-feenex-gold text-sm"></i>
                  </div>
                  <span className="text-white/70 text-sm">Parecer jurídico em cada operação</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-feenex-gold/10 rounded-full">
                    <i className="ri-bar-chart-box-line text-feenex-gold text-sm"></i>
                  </div>
                  <span className="text-white/70 text-sm">Até 20% de redução tributária</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Accordion */}
          <div className="lg:col-span-3 space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`border rounded-lg overflow-hidden transition-all duration-300 ${
                    isOpen
                      ? 'border-feenex-gold/40 shadow-md shadow-feenex-gold/5'
                      : 'border-gray-100 hover:border-feenex-blue/20'
                  }`}
                >
                  <button
                    onClick={() => toggle(index)}
                    className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left cursor-pointer bg-white hover:bg-gray-50/50 transition-colors"
                    aria-expanded={isOpen}
                  >
                    <span className={`text-sm font-semibold leading-snug transition-colors ${isOpen ? 'text-feenex-gold' : 'text-feenex-blue'}`}>
                      {faq.question}
                    </span>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 mt-0.5 ${
                      isOpen ? 'bg-feenex-gold text-white rotate-180' : 'bg-feenex-blue/5 text-feenex-blue'
                    }`}>
                      <i className="ri-arrow-down-s-line text-base"></i>
                    </div>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${
                      isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-6 pb-5 pt-1 border-t border-gray-50">
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
